import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

import { useEffect, useState } from "react";
import LoadingComponent from "../../app/layout/LoadingComponent";
import agent from "../../app/api/agent";
import { Order, OrderItem } from "../../app/models/order";
import { Delete, Edit } from "@mui/icons-material";
import { currencyFormat } from "../../app/util/util";

import OrderDetails from "./OrderDetails";
import { LoadingButton } from "@mui/lab";



export default function OrderList() {
  const [detailMode, setDetailMode] = useState(false)


  const [selectedOrder, setSelectedOrder] = useState<Order | undefined>(undefined)
  
  const [loading, setLoading] = useState(true)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [target, setTarget] = useState(0)
  const [orders, setOrders] = useState<Order[] | undefined>()
  useEffect(() => {
      agent.Admin.getAllOrders()
      .then((orderData) => {
        orderData.reverse()
        setOrders(orderData)
        setLoading(false)
      }
      )
  }, []
  )

  function itemQuantity (items : OrderItem[] = []) : number {
      let quantity = 0
      items.forEach((item) => quantity += item.quantity)
      return quantity
  }


  function orderDate(date : string = '') : string {
    // modify utc time to NZ time
      let NZHour = ''
      let array1 = date.split('T')
      let array2 = array1[1].split('.')
      let utcTime = array2[0].split(':')
      if (Number(utcTime[0]) >= 0 && Number(utcTime[0]) < 12) {
        NZHour = (Number(utcTime[0]) + 12).toString()
      } else if (Number(utcTime[0]) === 12) {
        NZHour = '00'
      } else if (Number(utcTime[0]) > 12 && Number(utcTime[0]) < 24) {
        NZHour = (Number(utcTime[0]) - 12).toString()
      }
      
      let NZTime = array1[0].concat(' ', NZHour).concat(':', utcTime[1]).concat(':', utcTime[2])
      return NZTime
  }

  function handleDetail(order: Order) {
      setSelectedOrder(order)
      setDetailMode(true)
  }
  function cancelDetail() {
    if (selectedOrder) setSelectedOrder(undefined)
    setDetailMode(false)
  }

  function handleDeleteOrder(id: number) {
    var result = window.confirm("Want to delete?");
      if (result) {
        setDeleteLoading(true)
        setTarget(id)
        agent.Admin.deleteOrder(id)
            .then(() => removeOrder(id))
            .catch(error => console.log(error))
            .finally(() => setDeleteLoading(false))
      }
    }

 function removeOrder(id: number) {
    let updatedOrders = orders?.filter((order) => order.id !== id)
    setOrders(updatedOrders)
 }


  if (loading) return <LoadingComponent message="Loading orders" />
  if (detailMode) return <OrderDetails order={selectedOrder} cancelDetail={cancelDetail} />

  return (
    <>
    <Box display='flex' justifyContent='space-between'>
        <Typography sx={{ p: 2 }} variant='h4'>Orders</Typography>
        
    </Box>
    <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableCell>Order Id</TableCell>
                    <TableCell align="left">Buyer Id</TableCell>
                    <TableCell align="right">Price</TableCell>
                    <TableCell align="center">Order Date</TableCell>
                   
                    <TableCell align="center">Item Quantity</TableCell>
                    <TableCell align="center">Order Status</TableCell>
                    <TableCell align="right"></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
              {orders &&
                orders.map((order) => (
                    <TableRow
                        key={order.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            {order.id}
                        </TableCell>
                        <TableCell align="left">
                            <Box display='flex' alignItems='center'>
                                {order.buyerId}
                            </Box>
                        </TableCell>
                        <TableCell align="right">{currencyFormat(order.total)}</TableCell>
                        <TableCell align="center">{orderDate(order.orderDate)}</TableCell>
                        
                        <TableCell align="center">{itemQuantity(order.orderItems)}</TableCell>
                        <TableCell align="center">{order.orderStatus}</TableCell>
                        <TableCell align="right">
                            
                            <Button color="primary" onClick={() => handleDetail(order)} startIcon={<Edit />} />
                            <LoadingButton loading={deleteLoading && target === order.id} startIcon={<Delete />} color='error' onClick={() => handleDeleteOrder(order.id)} />
                        </TableCell>
                    </TableRow>
                ))
              }
            </TableBody>
        </Table>
    </TableContainer>
    {/* {metaData && 
        <Box sx={{pt: 2}}>
            <AppPagination metaData={metaData} onPageChange={(page: number) => dispatch(setPageNumber({pageNumber: page}))}/>
        </Box>} */}
</>
  )
}